import React, { memo, useEffect, useState } from 'react'
import { required, useTranslate } from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { useQuery } from 'react-query'
import { AutoCompleteWithService } from 'src/components/uiElements/fields/AutoCompleteWithService'
import { destinationsServices } from 'src/services/external/destination.service'

export const GetCarFields = memo(({ record }) => {
  const translate = useTranslate()
  const [inputValue, setInputValue] = useState('')
  const [options, setOptions] = useState([
    {
      id: '012345',
      short_name: 'all',
      long_name: 'Todos',
    },
  ])
  const renter = useQuery('ext-car-renter', businessRuleServices.getRenterCar)

  const processResponse = (response) => {
    let result = []

    response.data.forEach((item) => {
      let processedData = item.data.map((d) => ({
        id: d._id,
        short_name: d.iata,
        long_name: d.label,
      }))
      result = [...result, ...processedData]
    })

    return result
  }

  useEffect(() => {
    if (inputValue && inputValue?.length > 0) {
      ;(async () => {
        let response = await destinationsServices.getDestinationCarByName(inputValue)
        let mapper_response = processResponse(response)
        setOptions(mapper_response)
      })()
    }
  }, [inputValue])

  return (
    <Grid container spacing={2}>
      <EditInputsWrap label={translate('ra.field.renter')} required>
        {renter.isLoading ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source='car.renter'
            options={renter.data || []}
            label=''
            optionsText={['long_name']}
            optionValue='short_name'
            size='small'
            showAllOption
            showSearch
            multiple
            defaultValue={record ? record?.car?.renter : undefined}
            validate={[required()]}
          />
        )}
      </EditInputsWrap>
      <EditInputsWrap label={translate('ra.field.country')} required>
        <AutoCompleteWithService source='car.destination' setInputValue={setInputValue} options={options} />
      </EditInputsWrap>
    </Grid>
  )
})
